import React from "react";
import {Route} from "react-router-dom";


const module = (shopApp) => {
	const Manufacturer = shopApp.dynamic(() => import("./Manufacturer"));

	const url = "/manufacturer/:manufacturerID";

	let config = {
		name: "Manufacturer",
		routes: [
			<Route key={url} path={url} component={Manufacturer}/>
		]
	};

	shopApp.registerPage(config);

};

export default module;
